import pageStore from 'stores/BackInStock/PageStore';
import submitModalStore from 'stores/BackInStock/Modal/SubmitModalStore';
import * as bisUtils from 'stores/BackInStock/Utils';
import * as utils from 'Utils';

function getBackInStockHandler(renderDOMCallback) {
  const bis = {};

  bis.showModal = function() {
    submitModalStore.show();
    renderDOMCallback();
  };

  bis.hideModal = function() {
    submitModalStore.hide();
  };

  bis.setProductData = async (productData) => {
    await pageStore.deserializeProduct(productData);
  };

  bis.onReady = function(callback) {
    pageStore.setOnReadyCallback(callback);
  };

  return bis;
}

// process all queued function calls `apiReady`
export default function apiReady(renderDOMCallback) {
  const bis = getBackInStockHandler(renderDOMCallback);

  const process = (args) => {
    var params = [].slice.call(args);
    var ns = params.shift();
    var method = params.shift();

    // bis namespace
    if (ns === "back_in_stock") {
      if (bis[method]) {
       bis[method].apply(bis, params);
      } else {
        console.log(`back_in_stock does not have a ${method} method`);
      }
    }
  };

  if (!window.OnVoardQueue) window.OnVoardQueue = {};
  if (!window.OnVoardApi) window.OnVoardApi = {};

  // process queued function calls
  const queue = window.OnVoardQueue.backInStock || [];
  for (var i in queue) {
    process(queue[i]);
  }

  // setup api endpoint after everything is ready
  window.OnVoardApi.backInStock = function(args) {
    process(args);
  };

  // this is to support testing api in dev
  if (!utils.isProduction()) {
    window.OnVoard = function() {
      process(arguments);
    };
  }
}
